import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import TableDeleteCell from '../../atoms/TableDeleteCell';
import TableNameCell from '../../atoms/TableNameCell';
import TableRestoreCell from '../../atoms/TableRestoreCell';
import ListModal from '../ListModal';

const Trash = ({
  deletedCount,
  deletedItems,
  isTrashOpen,
  itemList,
  closeTrash,
  deleteItem,
  restoreItem
}) => {
  const childProps = {
    emptyTableAlertProps: {
      message: 'Your Recycle Bin is empty!',
      numberOfColumns: 3
    },
    tablePaginationProps: {
      isPaginationOn: false
    }
  };
  return (
    <ListModal
      childProps={childProps}
      items={deletedItems}
      show={isTrashOpen}
      title={`Recycle Bin (${deletedCount})`}
      onHide={closeTrash}
    >
      {map(deletedItems, item => (
        <tr key={item._id}>
          <TableNameCell item={item} itemList={itemList} />
          <TableRestoreCell itemID={item._id} itemList={itemList} restoreItem={restoreItem} />
          <TableDeleteCell itemID={item._id} itemList={itemList} deleteItem={deleteItem} />
        </tr>
      ))}
    </ListModal>
  );
};

Trash.defaultProps = {
  deletedCount: 0,
  deletedItems: [],
  isTrashOpen: false,
  itemList: '',
  closeTrash: () => console.error('no trash to open')
};

Trash.propTypes = {
  deletedCount: PropTypes.number,
  deletedItems: PropTypes.arrayOf(PropTypes.object),
  isTrashOpen: PropTypes.bool,
  itemList: PropTypes.string,
  closeTrash: PropTypes.func,
  deleteItem: PropTypes.func.isRequired,
  restoreItem: PropTypes.func.isRequired
};

export default Trash;
